import { transparentize } from "polished";
import { useHistory } from "react-router-dom";
import { useSession } from "src/stores/Session";
import { useStore } from "src/stores/Store";
import { useUI } from "src/stores/UI";
import colors from "src/utils/colors";
import tw from "src/utils/tw";
import BackButton from "../buttons/BackButton";
import { BorderButton } from "../buttons/BorderButton";
import Container from "../layout/Container";

interface Props {
  title: string;
  subtitle?: string;
  onExit?: () => void;
  isRegister?: boolean;
  hideBackButton?: boolean;
  hideExit?: boolean;
  showSignOut?: boolean;
}

export function CartHeader(props: Props) {
  const store = useStore();
  const history = useHistory();
  const session = useSession();
  const ui = useUI();

  function exitCart() {
    if (props.onExit) {
      props.onExit();
    } else if (props.isRegister) {
      if (store.user) {
        if (store.user.isAdminOrAbove) {
          history.push("/admin/checkout");
        } else {
          history.push("/account");
        }
      } else {
        history.push("/");
      }
    } else {
      history.push("/find");
    }
  }

  function signOut() {
    store.signOut();
    session.clearSession();
    ui.setMenuOpen(false);

    setTimeout(() => {
      history.push("/logout");
    }, 150);
  }

  return (
    <div
      className={tw(
        store.user?.isSalesOrAbove
          ? "h-32"
          : props.showSignOut
            ? "h-24"
            : "h-28",
        "border-b",
        "border-borderGray",
        "fixed",
        "top-0",
        "left-0",
        "w-full",
        "z-30",
        "bg-white"
      )}
    >
      <div
        className={tw("h-full", store.user?.isSalesOrAbove ? "pt-11" : "pt-4")}
        css={{
          backgroundColor: store.isAdminArea
            ? colors.bgGray
            : transparentize(0.9, store.theme.orgColor),
        }}
      >
        <Container large>
          <div className="flex">
            <div className="flex-1">
              {!props.hideBackButton && (
                <BackButton
                  css={{
                    color: store.isAdminArea
                      ? colors.darkGray
                      : store.theme.orgColor,
                  }}
                  className="mb-1"
                />
              )}
              <div className="step-subhead">
                {props.subtitle || "New Registration"}
              </div>
              <h2 className="mb-0">{props.title}</h2>
            </div>

            {!props.hideExit && (
              <BorderButton onClick={exitCart} bgColor="#fff">
                {props.isRegister ? "Exit" : "Exit Cart"}
              </BorderButton>
            )}

            {props.showSignOut && (
              <BorderButton onClick={signOut} bgColor="#fff">
                Sign out
              </BorderButton>
            )}
          </div>
        </Container>
      </div>
    </div>
  );
}
